
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { contains, filter, append as append_1, choose, singleton as singleton_1, tryFind, ofArray, map } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { InspectionTemplateId__get_unwrap, FormState__getValidation, ReminderInterval, ReminderInterval__ToI18nString } from "../../../Shared/Shared.js";
import { safeHash, createObj, equals } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join, concat } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Hierarchy_buildTreeOrderedList } from "../../../Shared/Category.js";
import { FormContainer } from "../../../Components/FormContainer.js";
import { singleton, empty, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ErrorAlert } from "../../../Components/Alert.js";
import { Input } from "../../../Components/Input.js";
import { Msg } from "./Types.js";
import { map as map_1, defaultArg, unwrap } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { TextArea } from "../../../Components/TextArea.js";
import { MultiSelectWithColor, MultiCreatable, Select } from "../../../Components/Select.js";
import { DayWeekMonthYearInput } from "../../../Widgets/DayWeekMonthYearInput.js";
import { Checkbox } from "../../../Components/Checkbox.js";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { RouterModule_nav } from "../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { initEdit, update as update_1, initNew } from "./State.js";
import { Skeleton } from "../../../Components/Skeleton.js";

function InspectionTemplateForm(props) {
    const t = useTranslation()[0];
    const componentState = props.State.FormState.IsLoading ? "disabled" : "enabled";
    const header = (props.State.FormMode.tag === 1) ? t("inspection_template.edit") : t("inspection_template.create");
    const intervalOptions = map((interval) => ({
        label: t(ReminderInterval__ToI18nString(interval)),
        value: interval,
    }), ofArray([new ReminderInterval(0, []), new ReminderInterval(1, []), new ReminderInterval(2, []), new ReminderInterval(3, []), new ReminderInterval(4, []), new ReminderInterval(5, []), new ReminderInterval(6, [])]));
    const selectedInterval = tryFind((o) => equals(o.value, props.State.Interval), intervalOptions);
    const treeOptions = map((tupledArg) => {
        const l = tupledArg[0];
        return {
            color: l.ColorHex,
            label: concat(Array((tupledArg[1] * 4) + 1).join(" "), ...l.Name),
            value: l.Id,
        };
    }, Hierarchy_buildTreeOrderedList(props.Categories));
    const successfulResultValues = map((r) => ({
        label: r,
        value: r,
    }), props.State.SuccessfulResults);
    const failedResultValues = map((r_1) => ({
        label: r_1,
        value: r_1,
    }), props.State.FailedResults);
    const intervalAndResultsDisabled = props.State.IsUsed && (props.State.FormMode.tag === 1);
    const intervalComponentState = (intervalAndResultsDisabled ? true : (componentState === "disabled")) ? "disabled" : "enabled";
    return createElement(FormContainer, {
        Children: toList(delay(() => {
            let matchValue_3;
            return append((matchValue_3 = FormState__getValidation(props.State.FormState, t, "global"), (matchValue_3 == null) ? (empty()) : singleton(createElement(ErrorAlert, {
                Label: matchValue_3,
            }))), delay(() => append(singleton(createElement(Input, {
                ComponentState: componentState,
                Label: t("inspection_template.name"),
                OnChange: (v) => {
                    props.Dispatch(new Msg(3, [v]));
                },
                TestId: "inspection-template-name-input",
                ValidationMessage: unwrap(FormState__getValidation(props.State.FormState, t, "name")),
                Value: props.State.Name,
            })), delay(() => append(singleton(createElement(TextArea, {
                ComponentState: componentState,
                Label: t("inspection_template.description"),
                OnChange: (v_1) => {
                    props.Dispatch(new Msg(4, [v_1]));
                },
                TestId: "inspection-template-description-input",
                Value: props.State.Description,
            })), delay(() => append(singleton(createElement(Select, {
                ComponentState: intervalComponentState,
                IsClearable: false,
                Label: t("inspection_template.interval"),
                NoOptionsMessage: "select.no_options",
                OnChange: (selected) => {
                    if (selected == null) {
                    }
                    else {
                        props.Dispatch(new Msg(5, [selected.value]));
                    }
                },
                Options: intervalOptions,
                PlaceholderKey: "inspection_template.interval_placeholder",
                TestId: "inspection-template-interval-select",
                ValidationMessage: unwrap(FormState__getValidation(props.State.FormState, t, "interval")),
                Value: unwrap(selectedInterval),
            })), delay(() => {
                let Value_2;
                return append((props.State.Interval.tag === 6) ? singleton(createElement(DayWeekMonthYearInput, (Value_2 = (defaultArg(map_1((ci) => (ci.Value | 0), props.State.CustomInterval), 1) | 0), {
                    ComponentState: intervalComponentState,
                    InitialInterval: unwrap(map_1((ci_1) => ci_1.Interval, props.State.CustomInterval)),
                    IsBefore: false,
                    SetValue: (value_2) => {
                        let tupledArg_1;
                        props.Dispatch((tupledArg_1 = value_2, new Msg(6, [tupledArg_1[0], tupledArg_1[1]])));
                    },
                    Value: Value_2,
                }))) : (empty()), delay(() => append(singleton(Checkbox({
                    ComponentState: componentState,
                    IsChecked: props.State.NotificationInterval != null,
                    Label: t("inspection_template.notification_enabled"),
                    OnCheck: (_arg) => {
                        props.Dispatch(new Msg(7, [props.State.NotificationInterval == null]));
                    },
                    TestId: "inspection-template-notification-enabled-checkbox",
                })), delay(() => {
                    let matchValue_5, notificationInterval, elems;
                    return append((matchValue_5 = props.State.NotificationInterval, (matchValue_5 == null) ? (empty()) : ((notificationInterval = matchValue_5, singleton(reactElement("div", createObj(singleton_1((elems = toList(delay(() => append(singleton(reactElement("div", {
                        className: join(" ", ["text-sm", "mb-1"]),
                        children: t("inspection_template.notification_interval"),
                    })), delay(() => append(singleton(createElement(DayWeekMonthYearInput, {
                        ComponentState: componentState,
                        InitialInterval: notificationInterval.Interval,
                        IsBefore: true,
                        SetValue: (value_6) => {
                            let tupledArg_2;
                            props.Dispatch((tupledArg_2 = value_6, new Msg(8, [tupledArg_2[0], tupledArg_2[1]])));
                        },
                        Value: notificationInterval.Value,
                    })), delay(() => {
                        const matchValue_6 = FormState__getValidation(props.State.FormState, t, "notificationInterval");
                        if (matchValue_6 == null) {
                            return empty();
                        }
                        else {
                            const validationMessage = matchValue_6;
                            return singleton(reactElement("div", {
                                className: join(" ", ["text-sm", "text-red"]),
                                children: validationMessage,
                            }));
                        }
                    })))))), ["children", reactApi.Children.toArray(Array.from(elems))])))))))), delay(() => append(singleton(createElement(MultiCreatable, {
                        ComponentState: componentState,
                        IsClearable: true,
                        Label: t("inspection_template.successful_results"),
                        NoOptionsMessage: "select.no_options",
                        OnChange: (values) => {
                            props.Dispatch(new Msg(9, [choose((v_2) => map_1((item) => item.value, v_2), ofArray(values))]));
                        },
                        OnCreateOption: (value_11) => {
                            props.Dispatch(new Msg(9, [append_1(props.State.SuccessfulResults, singleton_1(value_11))]));
                        },
                        Options: map((r_2) => ({
                            label: r_2,
                            value: r_2,
                        }), props.State.SuccessfulResults),
                        PlaceholderKey: "inspection_template.results_placeholder",
                        ValidationMessage: unwrap(FormState__getValidation(props.State.FormState, t, "results")),
                        Value: successfulResultValues,
                    })), delay(() => append(singleton(createElement(MultiCreatable, {
                        ComponentState: componentState,
                        IsClearable: true,
                        Label: t("inspection_template.failed_results"),
                        NoOptionsMessage: "select.no_options",
                        OnChange: (values_1) => {
                            props.Dispatch(new Msg(10, [choose((v_3) => map_1((item_1) => item_1.value, v_3), ofArray(values_1))]));
                        },
                        OnCreateOption: (value_12) => {
                            props.Dispatch(new Msg(10, [append_1(props.State.FailedResults, singleton_1(value_12))]));
                        },
                        Options: map((r_3) => ({
                            label: r_3,
                            value: r_3,
                        }), props.State.FailedResults),
                        PlaceholderKey: "inspection_template.results_placeholder",
                        Value: failedResultValues,
                    })), delay(() => append(singleton(createElement(MultiSelectWithColor, {
                        ComponentState: componentState,
                        IsClearable: true,
                        Label: t("inspection_template.categories"),
                        NoOptionsMessage: "select.no_options",
                        OnChange: (arg) => {
                            props.Dispatch(new Msg(11, [arg]));
                        },
                        Options: filter((o_1) => !contains(o_1.value, props.State.SelectedCategoryIds, {
                            Equals: equals,
                            GetHashCode: (x) => (safeHash(x) | 0),
                        }), treeOptions),
                        PlaceholderKey: "inspection_template.categories_placeholder",
                        TestId: "inspection-template-categories-select",
                        Value: filter((o_2) => contains(o_2.value, props.State.SelectedCategoryIds, {
                            Equals: equals,
                            GetHashCode: (x_1) => (safeHash(x_1) | 0),
                        }), treeOptions),
                    })), delay(() => (intervalAndResultsDisabled ? singleton(reactElement("div", {
                        className: join(" ", ["text-sm", "text-text-muted", "italic"]),
                        children: t("inspection_template.is_used_hint"),
                    })) : empty())))))))));
                }))));
            }))))))));
        })),
        FormState: props.State.FormState,
        Header: header,
        OnBack: () => {
            const matchValue_2 = props.State.FormMode;
            if (matchValue_2.tag === 1) {
                RouterModule_nav(ofArray(["inspection-templates", InspectionTemplateId__get_unwrap(matchValue_2.fields[0])]), 1, 1);
            }
            else {
                RouterModule_nav(ofArray(["inspection-templates"]), 1, 1);
            }
        },
        OnSave: () => {
            props.Dispatch(new Msg(12, []));
        },
    });
}

export function NewView() {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initNew, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.Categories;
    if (matchValue.tag === 0) {
        return createElement(Skeleton, {
            Variant: "table",
        });
    }
    else {
        return createElement(InspectionTemplateForm, {
            Categories: matchValue.fields[0],
            Dispatch: patternInput[1],
            State: state_1,
        });
    }
}

export function EditView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => initEdit(props.TemplateId), update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.Categories;
    let matchResult, categories;
    if (matchValue.tag === 1) {
        if (state_1.TemplateLoaded) {
            matchResult = 0;
            categories = matchValue.fields[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return createElement(InspectionTemplateForm, {
                Categories: categories,
                Dispatch: patternInput[1],
                State: state_1,
            });
        default:
            return createElement(Skeleton, {
                Variant: "table",
            });
    }
}

